import { AnyAction } from 'redux'

import { IUserStatus } from 'models/user.model'

import {
  SET_COOKIE_CONSENT,
  SET_ONE_LINK,
  SET_STATUS,
  SET_UTM_TAGS,
  SET_UUID,
  UPDATE_USER_CONFIG,
} from '../actions/user'

export interface IUserState {
  uuid: string
  oneLink: string
  status: IUserStatus | null
  utmTags: Record<string, string> | null
  cookieConsent: string[] | null
}

const initState: IUserState = {
  uuid: '',
  oneLink: '',
  status: null,
  utmTags: null,
  cookieConsent: null,
}

export function userReducer(
  state: IUserState = initState,
  { type, payload = null }: AnyAction,
): IUserState {
  switch (type) {
    case SET_UUID: {
      return {
        ...state,
        uuid: payload,
      }
    }
    case SET_STATUS: {
      return {
        ...state,
        status: payload,
      }
    }
    case SET_ONE_LINK: {
      return {
        ...state,
        oneLink: payload,
      }
    }
    case SET_UTM_TAGS: {
      return {
        ...state,
        utmTags: payload,
      }
    }
    case SET_COOKIE_CONSENT: {
      return {
        ...state,
        cookieConsent: payload,
      }
    }
    case UPDATE_USER_CONFIG: {
      return {
        ...state,
        ...(state.status && {
          status: {
            ...state.status,
            config: {
              ...state.status.config,
              ...payload,
            },
          },
        }),
      }
    }
    default:
      return state
  }
}
